import { render, staticRenderFns } from "./AppBarChartTable.vue?vue&type=template&id=63d4c3a5&scoped=true&"
import script from "./AppBarChartTable.vue?vue&type=script&lang=js&"
export * from "./AppBarChartTable.vue?vue&type=script&lang=js&"
import style0 from "./AppBarChartTable.vue?vue&type=style&index=0&id=63d4c3a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4c3a5",
  null
  
)

export default component.exports